import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import { default as FillsReducer } from './Fills'

export * from './Fills'

export const types = {
  ...makeApiTypes('FETCH_FILLS', 'fills'),
  CLEAR_FILLS: 'fills/CLEAR_FILLS',
}

export const initialState = {
  // Candidate fills fetched from the pharmacy-fills gateway for the member's
  // expense-submission picker (G20-3094). Linking is handled by the submission
  // itself (evaluate-submission with `fill_uuids`), so there is no separate
  // match state here.
  fills: { busy: false, error: null, entities: null },
}

export default reduceReducers(
  FillsReducer,
  // initialState MUST be last
  initialState,
)
